export enum FEATURE_TOGGLE_DEV {
  CHAMPION_PERMISSION = 'championsPermissionDev',
  ORGANIZATION_CHAMPION_PERMISSION = 'organizationChampionPermissionDev',
  PROJECT_CHAMPION_PERMISSION = 'projectChampionPermissionDev',
  PORTFOLIO_CHAMPION_PERMISSION = 'portfolioChampionPermissionDev',
  ORGANIZATION_ALLOWED_CHAMPION_PERMISSION = 'orgAllowedPermissionDev',
  MODERNIZED_DESIGN = 'modernizedDesignDev',
}

export enum FEATURE_TOGGLE_TEST {
  CHAMPION_PERMISSION = 'championsPermissionTest',
  ORGANIZATION_CHAMPION_PERMISSION = 'organizationChampionPermissionTest',
  PROJECT_CHAMPION_PERMISSION = 'projectChampionPermissionTest',
  PORTFOLIO_CHAMPION_PERMISSION = 'portfolioChampionPermissionTest',
  ORGANIZATION_ALLOWED_CHAMPION_PERMISSION = 'orgAllowedPermissionTest',
  MODERNIZED_DESIGN = 'modernizedDesignTest',
}

export enum FEATURE_TOGGLE_STAGING {
  CHAMPION_PERMISSION = 'championsPermissionProd',
  ORGANIZATION_CHAMPION_PERMISSION = 'organizationChampionPermissionProd',
  PROJECT_CHAMPION_PERMISSION = 'projectChampionPermissionProd',
  PORTFOLIO_CHAMPION_PERMISSION = 'portfolioChampionPermissionProd',
  ORGANIZATION_ALLOWED_CHAMPION_PERMISSION = 'orgAllowedPermissionProd',
  MODERNIZED_DESIGN = 'modernizedDesignStaging',
}

export enum FEATURE_TOGGLE_PROD {
  CHAMPION_PERMISSION = 'championsPermissionProd',
  ORGANIZATION_CHAMPION_PERMISSION = 'organizationChampionPermissionProd',
  PROJECT_CHAMPION_PERMISSION = 'projectChampionPermissionProd',
  PORTFOLIO_CHAMPION_PERMISSION = 'portfolioChampionPermissionProd',
  ORGANIZATION_ALLOWED_CHAMPION_PERMISSION = 'orgAllowedPermissionProd',
  MODERNIZED_DESIGN = 'modernizedDesignProd',
}
